import React from 'react';
import PropTypes from 'prop-types';
import cn from '../../../utils/tools/cn';

import styles from './SkeletonLoader.module.scss';

function SkeletonLoader({
  width, height, className, radius,
}) {
  return (
    <div className={cn([styles.loading_container, className])} style={{ width, height, borderRadius: radius }} />
  );
}

SkeletonLoader.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  radius: PropTypes.number,
};

SkeletonLoader.defaultProps = {
  width: '100%',
  height: '100%',
  className: '',
  radius: 0,
};

export default SkeletonLoader;
